const mainTheme = {
  color: {
    primary: '#03414E',
    secondary: '#F68D2D',
    alternate: '#F8B133',
    grey: '#D1D4DD',
    dark: '#5E5E5E',
    light: '#FFFFFF',
  },

  font: {
    family: {
      primary: 'proxima-nova, sans-serif',
      secondary: 'museo, sans-serif',
    },

    size: {
      tiny: '10px',
      small: '14px',
      medium: '16px',
      big: '18px',
      large: '24px',
      huge: '30px',
      mega: '40px',
      giga: '60px',
    },

    weight: {
      light: 300,
      regular: 400,
      bold: 600,
      extraBold: 800,
    },
  },
}

export default mainTheme
